import React from 'react';

import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';

const ErrorAlert = ({ error = null, onDismiss = null }) => {
    if (!error) return null;

    return (
        <Alert
            variant="danger"
            dismissible={Boolean(onDismiss)}
            className="error-alert"
            onClose={onDismiss}
        >
            <Alert.Heading>
                Error
            </Alert.Heading>
            <p className="mb-0">{error}</p>
        </Alert>
    );
};

ErrorAlert.propTypes = {
    error: PropTypes.string,
    onDismiss: PropTypes.func,
};

export default ErrorAlert;

